<template>
  <el-dialog :title="title" :visible.sync="Dialog" width="64%" center :close-on-click-modal="false">
    <el-form :rules="rules" ref="teacherFrom" size="small" label-width="120px" :model="requestData">

      <el-form-item label="项目"  prop="name">
        <el-cascader :options="options" v-model="requestData.name" clearable></el-cascader>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="requestData.remarks" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item label="开始时间"  prop="start_grade">
        <el-select v-model="requestData.start_grade" placeholder="请选择">
          <el-option
            v-for="(item, index) in grade"
            :key="index"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        &nbsp;&nbsp;
        <el-select v-model="requestData.start_time" placeholder="请选择">
          <el-option
            v-for="(item, index) in month"
            :key="index"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结束时间"  prop="end_grade">
        <el-select v-model="requestData.end_grade" placeholder="请选择">
          <el-option
            v-for="(item, index) in grade"
            :key="index"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        &nbsp;&nbsp;
        <el-select v-model="requestData.end_time" placeholder="请选择">
          <el-option
            v-for="(item, index) in month"
            :key="index"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="Dialog = false">取 消</el-button>
       <el-popconfirm title="是否确定删除？" @confirm="confirmDel" v-if="requestData.id">
        <el-button size="mini" slot="reference" type="danger" style="margin-left: 20px;margin-right: 20px">删 除</el-button>
      </el-popconfirm>
      <el-button size="mini" type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { add_project_planning, del_project_planning,get_project_planning_year } from '@/api/mycenter_studyabroad'
export default {
  data() {
    return {
      options: [ {
        value: '学术项目',
        label: '学术项目',
        children: [{
          value: '科研',
          label: '科研'
        }, {
          value: '论文',
          label: '论文'
        }, {
          value: '比赛',
          label: '比赛'
        }, {
          value: '课程',
          label: '课程'
        }]
      }, {
        value: '工作经历',
        label: '工作经历',
        children: [{
          value: '全职',
          label: '全职'
        }, {
          value: '实习',
          label: '实习'
        }, {
          value: '实训',
          label: '实训'
        }, {
          value: '兼职',
          label: '兼职'
        }]
      }, {
        value: '荣誉奖励',
        label: '荣誉奖励',
        children: [{
          value: '奖学金',
          label: '奖学金'
        }, {
          value: '竞赛',
          label: '竞赛'
        }, {
          value: '义工',
          label: '义工'
        }, {
          value: '其他',
          label: '其他'
        }]
      }, {
        value: '课外活动',
        label: '课外活动',
        children: [{
          value: '课外活动',
          label: '课外活动'
        }]
      }, {
        value: '语言',
        label: '语言',
        children: [{
          value: '雅思',
          label: '雅思'
        }, {
          value: 'GRE',
          label: 'GRE'
        }, {
          value: 'GMAT',
          label: 'GMAT'
        }, {
          value: 'PTE',
          label: 'PTE'
        }]
      }],
      rules: {
        name: [
          { required: true, message: "项目不能为空", trigger: "change" },
        ],
        start_grade: [
          { required: true, message: "开始时间不能为空", trigger: "change" },
        ],
        end_grade: [
          { required: true, message: "结束时间不能为空", trigger: "change" },
        ]
      },
      grade: [],
      month: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      // options: ['雅思', '实习', '科研', '论文', 'gmat', 'gre'],
      requestData: {
        id: '',
        name: '',
        start_grade: '',
        start_time: '',
        end_grade: '',
        remarks: '',
        end_time: '',
        user_id: this.$route.query.userId
      },
      title: '',
      Dialog: false,
      type: 1 // 1新增,2修改
    }
  },
  created() {
    this.get_project_planning_year();
  },
  methods: {
    sendItem(_content,_grade_name,_month_name) {
      console.log('_content',_content)
      this.$forceUpdate()
      if (_content && _content.id) {
        this.title = '修改'
        this.requestData.id = _content.id
        this.requestData.name = _content.name_list
        this.requestData.start_grade = _content.start_grade
        this.requestData.start_time = _content.start_time
        this.requestData.remarks = _content.remarks
        this.requestData.end_grade = _content.end_grade
        this.requestData.end_time = _content.end_time
      } else {
        this.title = '添加'
        this.requestData.id = null
        this.requestData.name = null
        this.requestData.start_grade = null
        this.requestData.start_time = null
        this.requestData.remarks = null
        this.requestData.end_grade = null
        this.requestData.end_time = null
      }
      if (_grade_name && _month_name) {
        this.requestData.start_grade = _grade_name
        this.requestData.start_time = _month_name
      }
      this.Dialog = true
    },
    get_project_planning_year(){
      get_project_planning_year(this.requestData)
        .then(response => {
          this.grade = response.data.data
        })
        .catch(error => {
        })
    },
    confirmDel() {
      del_project_planning(this.requestData)
        .then(response => {
          this.Dialog = false
          this.$emit('certain')
        })
        .catch(error => {
        })
    },
    confirmHandle() {
      if (!this.requestData.name) {
        this.$message.error('名称不能为空')
        return
      }
      if (!this.requestData.start_grade) {
        this.$message.error('开始时间不能为空')
        return
      }
      if (!this.requestData.start_time) {
        this.$message.error('开始时间不能为空')
        return
      }
      if (!this.requestData.end_grade) {
        this.$message.error('结束时间不能为空')
        return
      }
      if (!this.requestData.end_time) {
        this.$message.error('结束时间不能为空')
        return
      }
      add_project_planning(this.requestData)
        .then(response => {
          if (response.code != 200) {
            this.$message.error('时间格式不正确')
          } else {
            this.Dialog = false
            this.$emit('certain')
          }
        })
        .catch(error => {
          console.log('error',error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.hb-user-profile-edit-page .el-form-item{
  margin-bottom: 18px !important
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/addVisaProcess.vue